// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accept-icon-button {
  width: 2.35rem !important;
  height: auto;
  background-color: #3BBB48 !important;
  border-radius: 25%;
}

.accept-icon-button:hover {
  cursor: pointer;
  background-color: #3DDB4D !important;
}

.accept-icon-button:focus {
  box-shadow: none !important;
  background-color: #2B9436 !important;
}

.accept-icon-button:disabled {
  background-color: #DBDBDB !important;
}

.reject-icon-button {
  width: 2.35rem !important;
  height: auto;
  background-color: #E52323 !important;
  border-radius: 25%;
}

.reject-icon-button:hover {
  cursor: pointer;
  background-color: #FF3737 !important;
}

.reject-icon-button:focus {
  box-shadow: none !important;
  background-color: #B61717 !important;
}

.reject-icon-button:disabled {
  background-color: #DBDBDB !important;
}

.delete-icon-button {
  width: 2.35rem !important;
  height: auto;
  background-color: rgb(31, 31, 31) !important;
  border-radius: 25%;
}

.delete-icon-button:hover {
  cursor: pointer;
  background-color: black !important;
}

.delete-icon-button:focus {
  box-shadow: none !important;
}

.delete-icon-button:disabled {
  background-color: #DBDBDB !important;
}

.edit-icon-button {
  width: 2.35rem !important;
  height: auto;
  background-color: rgb(19, 75, 181) !important;
  border-radius: 25%;
}

.edit-icon-button:hover {
  cursor: pointer;
  background-color: blue !important;
}

.edit-icon-button:focus {
  box-shadow: none !important;
}

.edit-icon-button:disabled {
  background-color: #DBDBDB !important;
}

.add-icon-button {
  width: 2.35rem !important;
  height: auto;
  background: rgb(199, 4, 113) !important;
  border-radius: 25%;
}

.add-icon-button:hover {
  cursor: pointer;
  background-color: rgb(199, 4, 113) !important;
}

.add-icon-button:focus {
  box-shadow: none !important;
  background-color: rgb(199, 4, 113) !important;
}

.add-icon-button:disabled {
  background-color: #DBDBDB !important;
}

.download-icon-button {
  width: 2.35rem !important;
  height: auto;
  background-color: #DF175F !important;
  border-radius: 25%;
}

.download-icon-button:hover {
  cursor: pointer;
  background-color: #FE357D !important;
}

.download-icon-button:focus {
  box-shadow: none !important;
  background-color: #C21352 !important;
}

.download-icon-button:disabled {
  background-color: #DBDBDB !important;
}`, "",{"version":3,"sources":["webpack://./src/components/IconButton.scss"],"names":[],"mappings":"AAOA;EAJI,yBAAA;EACA,YAAA;EAKA,oCAAA;EACA,kBAAA;AALJ;;AAQA;EACI,eAAA;EACA,oCAAA;AALJ;;AAQA;EACI,2BAAA;EACA,oCAAA;AALJ;;AAQA;EACI,oCAAA;AALJ;;AAQA;EAxBI,yBAAA;EACA,YAAA;EAyBA,oCAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,oCAAA;AAJJ;;AAOA;EACI,2BAAA;EACA,oCAAA;AAJJ;;AAOA;EACI,oCAAA;AAJJ;;AAOA;EA5CI,yBAAA;EACA,YAAA;EA6CA,4CAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,kCAAA;AAHJ;;AAMA;EACI,2BAAA;AAHJ;;AAOA;EACI,oCAAA;AAJJ;;AAOA;EAhEI,yBAAA;EACA,YAAA;EAiEA,6CAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,iCAAA;AAHJ;;AAMA;EACI,2BAAA;AAHJ;;AAOA;EACI,oCAAA;AAJJ;;AAOA;EApFI,yBAAA;EACA,YAAA;EAsFA,uCAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,6CAAA;AAJJ;;AAOA;EACI,2BAAA;EACA,6CAAA;AAJJ;;AAOA;EACI,oCAAA;AAJJ;;AAOA;EAzGI,yBAAA;EACA,YAAA;EA0GA,oCAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,oCAAA;AAHJ;;AAMA;EACI,2BAAA;EACA,oCAAA;AAHJ;;AAMA;EACI,oCAAA;AAHJ","sourcesContent":["@import \"../data/colors.scss\";\n\n@mixin icon-button-size {\n    width: 2.35rem !important;\n    height: auto;\n}\n\n.accept-icon-button {\n    @include icon-button-size;\n    background-color: $acceptButtonActive !important;\n    border-radius: 25%\n}\n\n.accept-icon-button:hover {\n    cursor: pointer;\n    background-color: $acceptButtonHover !important;\n}\n\n.accept-icon-button:focus {\n    box-shadow: none !important;\n    background-color: $acceptButtonFocus !important;\n}\n\n.accept-icon-button:disabled {\n    background-color: $iconButtonDisabled !important;\n}\n\n.reject-icon-button {\n    @include icon-button-size;\n    background-color: $rejectButtonActive !important;\n    border-radius: 25%\n}\n\n.reject-icon-button:hover {\n    cursor: pointer;\n    background-color: $rejectButtonHover !important;\n}\n\n.reject-icon-button:focus {\n    box-shadow: none !important;\n    background-color: $rejectButtonFocus !important;\n}\n\n.reject-icon-button:disabled {\n    background-color: $iconButtonDisabled !important;\n}\n\n.delete-icon-button {\n    @include icon-button-size;\n    background-color: $deleteButtonActive !important;\n    border-radius: 25%\n}\n\n.delete-icon-button:hover {\n    cursor: pointer;\n    background-color: $deleteButtonHover !important;\n}\n\n.delete-icon-button:focus {\n    box-shadow: none !important;\n    // background-color: $deleteButtonFocus !important;\n}\n\n.delete-icon-button:disabled {\n    background-color: $iconButtonDisabled !important;\n}\n\n.edit-icon-button {\n    @include icon-button-size;\n    background-color: $editButtonActive !important;\n    border-radius: 25%\n}\n\n.edit-icon-button:hover {\n    cursor: pointer;\n    background-color: $editButtonHover !important;\n}\n\n.edit-icon-button:focus {\n    box-shadow: none !important;\n    // background-color: $editButtonFocus !important;\n}\n\n.edit-icon-button:disabled {\n    background-color: $iconButtonDisabled !important;\n}\n\n.add-icon-button {\n    @include icon-button-size;\n    // background-color: $addButtonActive !important;\n    background: rgba(199, 4, 113, 1) !important;\n    border-radius: 25%\n}\n\n.add-icon-button:hover {\n    cursor: pointer;\n    background-color: rgba(199, 4, 113, 1) !important;\n}\n\n.add-icon-button:focus {\n    box-shadow: none !important;\n    background-color: rgba(199, 4, 113, 1) !important;\n}\n\n.add-icon-button:disabled {\n    background-color: $iconButtonDisabled !important;\n}\n\n.download-icon-button {\n    @include icon-button-size;\n    background-color: $downloadButtonActive !important;\n    border-radius: 25%\n}\n\n.download-icon-button:hover {\n    cursor: pointer;\n    background-color: $downloadButtonHover !important;\n}\n\n.download-icon-button:focus {\n    box-shadow: none !important;\n    background-color: $downloadButtonFocus !important;\n}\n\n.download-icon-button:disabled {\n    background-color: $iconButtonDisabled !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
